export default {
      id: "icon-sinirsiz-internet-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-sinirsiz-internet",
      toString: function () {
        return this.url;
      }
    }